import { render } from "./FreePracticeRecordSubject.vue?vue&type=template&id=cc225bb8&scoped=true&ts=true"
import script from "./FreePracticeRecordSubject.vue?vue&type=script&lang=ts"
export * from "./FreePracticeRecordSubject.vue?vue&type=script&lang=ts"

import "./FreePracticeRecordSubject.vue?vue&type=style&index=0&id=cc225bb8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc225bb8"]])

export default __exports__